import { useEffect, useMemo, useState } from 'react';
import { SkupremeModal } from '../../components';
import { HoverBorderButton, MuteText, StyledButton } from '../../elements';
import { PalletSearchInput } from '../pallet/PalletSearch';
import { CommonUtility, InventoryService, ToastMessage } from '../../utility';

export function EditPallet({ warehouseId, open, onClose, item, refresh }) {
  const [loading, setLoading] = useState(false);
  const [currentPallet, setCurrentPallet] = useState(null);
  const [resetDataKey, setResetDataKey] = useState('');

  const refreshPalletData = () => {
    setResetDataKey(Math.random());
  };

  useEffect(() => {
    setCurrentPallet(item?.lot?.pallet || null);
  }, [item]);

  const shouldDelete = useMemo(() => {
    if (CommonUtility.isValidObject(item?.lot?.pallet)) {
      return !CommonUtility.isValidObject(currentPallet);
    }
    return false;
  }, [currentPallet, item]);

  const submit = async () => {
    if (item?.lot?.pallet?._id === currentPallet?._id) {
      onClose();
      return;
    }

    const payload = {
      adjustmentType: 'pallet_association',
      palletNumber: shouldDelete
        ? item?.lot?.pallet?.palletNumber
        : currentPallet?.palletNumber,
      isNewPallet: currentPallet?.newData || false,
      removePallet: shouldDelete,
    };

    try {
      setLoading(true);
      await InventoryService.updateInventory(item?.lot?.inventoryId, payload);
      ToastMessage.success('Pallet configuration updated successfully');
      refreshPalletData();
      refresh();
      onClose();
    } catch (error) {
      ToastMessage.apiError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <SkupremeModal title="Pallet Configuration" open={open} onClose={onClose} size="mini">
      <PalletSearchInput
        defaultValue={item?.lot?.pallet?.palletNumber}
        warehouseId={warehouseId}
        onResultClick={setCurrentPallet}
        inputClassName="w-100"
        resetDataKey={resetDataKey}
        allowCreate
      />
      {shouldDelete && <MuteText>Clicking confirm will remove Pallet.</MuteText>}
      <div className="d-flex justify-content-end mt-4">
        <HoverBorderButton disabled={loading} onClick={onClose}>
          Close
        </HoverBorderButton>
        <StyledButton onClick={submit} loading={loading} className="ml-2">
          Confirm
        </StyledButton>
      </div>
    </SkupremeModal>
  );
}
